import { useAuth0 } from "@auth0/auth0-react";
import { useIntl } from "react-intl";

export const Logout = () => {
  const { formatMessage } = useIntl();
  const { logout } = useAuth0();

  return (
    <div>
      <div className="app-settings-content-block-title">{formatMessage({ id: "app.settings.user.options" })}</div>
      <div
        className={"logout"}
        onClick={() => {
          logout({
            logoutParams: {
              returnTo: window.location.origin,
            },
          });
        }}
      >
        <i className="fa-solid fa-right-from-bracket logout-icon" />
        <div className="logout-text">{formatMessage({ id: "logout" })}</div>
      </div>
    </div>
  );
};
